export default {
    rg: '1rem', // 14px;
    xs: '1.1428571428571428em', // 16px
    sm: '1.2857142857142858em', // 18px
    md: '1.4285714285714286em', // 20px
    lg: '1.7142857142857142em', // 24px
    xl: '2.5714285714285716em', // 36px
}
